import React, {ReactElement, useState} from "react"
import Grid from "@mui/material/Grid";
import {Code} from "../../Code";
import {ICode} from "../../interfaces/code";
import {Button} from "../../../../App/components/Button";

interface Props {
  onClose: (code: ICode) => void
}

export function Create(props: Props): ReactElement | null {
  const { onClose } = props
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Grid item>
      <Button
        size="large"
        type="button"
        onClick={handleOpen}
      >
        Добавить
      </Button>
      {open ? (
        <Code
          open={open}
          onClose={(code?: ICode) => {
            if (code) {
              onClose(code)
            }
            setOpen(false);
          }}
        />
      ): null}
    </Grid>
  )
}
